import { gql } from "@apollo/client";
import { Animal, AnimalInfo, NORMALIZED_ANIMAL_FRAGMENT, PANEL_ANIMAL_FRAGMENT } from "../../AnimalDataCalls/GQLCalls/getAnimalCall";

export const GET_LF_SECTION_INFO = gql`
  query SectionInfo($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String, $ifFeedCurveBaseInfoOnly: Boolean!, 
  $ifFeedCurveInfo: Boolean!, $ifSpreading: Boolean!, $ifSkipConsumption: Boolean!, $ifSkipLastTenDaysConsumption: Boolean!) {
    section {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        section_id
        name
        panel_section_type
        section_order
        section_locations {
          name,
          location_id
          visual
          stations
          animals(domain: $domain) {
            ...AnimalFields
          }
        }
        system_id
      }
    }
  }
${PANEL_ANIMAL_FRAGMENT}
`
export const GET_SECTION_INFO = gql`
  query SectionInfo($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String) {
    section {
      info(domain: $domain, input: $input, idIdentifier: $idIdentifier) {
        section_id
        name
        panel_section_type
        section_order
        section_locations {
          name,
          location_id
          visual
          stations
          animals(domain: $domain) {
            ...NormalizedAnimalFields
          }
        }
        system_id
      }
    }
  }
${NORMALIZED_ANIMAL_FRAGMENT}
`

export interface Section {
  section_id: number;
  system_id: number;
  name: string;
  panel_section_type: number;
  section_locations: Location[];
  section_order: number;
}

export interface Location {
  name: string,
  location_id: number,
  visual?: string;
  stations: number[];
  animals: Animal[]
}

export interface SectionResponse {
  section: {
    info: Section[]
  }
}

/**
 * @deprecated
 */
export interface SectionsInfo {
  section_id: number;
  system_id: number;
  name: string;
  panel_section_type: number;
  section_locations: LocationInfo[]
  section_order: number;
}

/**
 * @deprecated
 */
export interface LocationInfo {
  name: string,
  location_id: number;
  visual?: string;
  stations: number[];
  animals: AnimalInfo[];
}

/**
 * @deprecated
 */
export interface SectionInfoResponse {
  section: {
    info: SectionsInfo[]
  }
}


// export const GET_LF_SECTION_INFO = gql`
//   query Info($domain: String!, $input: BasicQueryInfoInput!, $idIdentifier: String, $ifFeedCurveBaseInfoOnly: Boolean!, $ifFeedCurveInfo: Boolean!, $ifSpreading: Boolean!, $ifSkipConsumption: Boolean!, $ifSkipLastTenDaysConsumption: Boolean!) {
//     section {
//       info(domain: $domain, input: $input) {
//         section_id
//         name
//         panel_section_type
//         section_locations {
//           name,
//           location_id
//           visual
//           animals(domain: $domain) {
//             ...AnimalFields
//           }
//         }
//         system_id
//       }
//     }
//   }
// ${PANEL_ANIMAL_FRAGMENT}
// `
